////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, findIndex } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const distributionGroupRepository = {
	[ActionsTypes.POST_DISTRIBUTION_GROUP]: (state) =>
		update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.POST_DISTRIBUTION_GROUP_SUCCESS]: (state, payload) => {
		let paging = cloneDeep(payload.data.headerContent.contentPagined)
		let items = cloneDeep(payload.data.headerContent.contentPagined.content)
		let filters = cloneDeep(payload.data.headerParam.filters)
		return update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: false,
				},
				paging: {
					$set: paging,
				},
				items: {
					$set: items,
				},
				header: {
					$set: filters,
				},
			},
		})
	},
	[ActionsTypes.POST_DISTRIBUTION_GROUP_FAILURE]: (state, payload) =>
		update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.POST_ACTIVE_ITEM]: (state) =>
		update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
				update: {
					$set: false,
				},
			},
		}),

	[ActionsTypes.POST_ACTIVE_ITEM_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)
		const stateCp = cloneDeep(state.distributionGroupRepository.paging.content)
		const idx = findIndex(stateCp, { itemId: data.itemId })
		stateCp[idx] = data
		return update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: stateCp,
				},
				update: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_ACTIVE_ITEM_FAILURE]: (state, payload) =>
		update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				update: {
					$set: false,
				},
			},
		}),

	[ActionsTypes.POST_DELETE_ITEM]: (state) =>
		update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				deleteSuccess: {
					$set: false,
				},
			},
		}),

	[ActionsTypes.POST_DELETE_ITEM_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)
		const stateCp = cloneDeep(state.distributionGroupRepository.paging.content)
		const idx = findIndex(stateCp, { itemId: data.itemId })
		stateCp[idx] = data

		return update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: stateCp,
				},
				deleteSuccess: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_DELETE_ITEM_FAILURE]: (state, payload) =>
		update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				deleteSuccess: {
					$set: false,
				},
			},
		}),

	[ActionsTypes.GET_ITEM_DETAIL]: (state) =>
		update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
		}),
	[ActionsTypes.GET_ITEM_DETAIL_SUCCESS]: (state, payload) => {
		let itemDetail = payload.data

		return update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: false,
				},
				itemsDetail: {
					$set: itemDetail,
				},
			},
		})
	},
	[ActionsTypes.GET_ITEM_DETAIL_FAILURE]: (state, payload) =>
		update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.SET_ITEM_ID]: (state, payload) => {
		return update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: false,
				},
				id: {
					$set: payload.id,
				},
			},
		})
	},

	[ActionsTypes.POST_DEACTIVATE_REF_ITEM]: (state) =>
		update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),

	[ActionsTypes.POST_DEACTIVATE_REF_ITEM_SUCCESS]: (state, _payload) => {
		return update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: false,
				},
				update: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_DEACTIVATE_REF_ITEM_FAILURE]: (state, payload) =>
		update(state, {
			distributionGroupRepository: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.RESET_DISTRIBUTION_GROUP]: (state, _payload) => {
		return update(state, {
			distributionGroupRepository: {
				items: {
					$set: [],
				},
				update: {
					$set: false,
				},
				deleteSuccess: {
					$set: false,
				},
			},
		})
	},
}

export default distributionGroupRepository
